import {
  ADD_FILE,
  ADD_QUERY,
  ADD_EMAIL,
  DELETE_FILE,
  FileActionTypes,
  FileData,
  QueryData,
  EmailData,
} from "../actions";

interface FileState {
  files: FileData[];
  queries: QueryData[];
  emails: EmailData[];
}

const initialState: FileState = {
  files: [],
  queries: [],
  emails: [],
};

const fileReducer = (
  state = initialState,
  action: FileActionTypes
): FileState => {
  switch (action?.type) {
    case ADD_FILE:
      return {
        ...state,
        files: Array.isArray(action?.payload)
          ? action?.payload
          : [action?.payload],
      };
    case ADD_QUERY:
      return {
        ...state,
        queries: Array.isArray(action?.payload)
          ? action?.payload
          : [action?.payload],
      };
    case ADD_EMAIL:
      return {
        ...state,
        emails: Array.isArray(action?.payload)
          ? action?.payload
          : [action?.payload],
      };

    case DELETE_FILE:
      return {
        ...state,
        files: state?.files?.filter((file) => file?.id !== action?.payload),
      };

    default:
      return state;
  }
};

export default fileReducer;
